import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import PageHeading from "../../Components/PageHeading/PageHeading";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import moment from "moment";

export default function GeneratedToyStoriesAi() {
    const { AIuser } = useContext(UserAuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    const [selectedImage, setSelectedImage] = useState(null);

    const data = location.state;

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!data) {
            navigate("/usage");
        }
    }, [data, navigate]);

    if (!data) {
        return (
            <div>
                <PageHeading
                    title={"GENERATED Toy Stories AI"}
                    description={"View your generated Toy Stories AI"}
                />
                <div className="container text-center" style={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <h5 className="text-white">No data found</h5>
                </div>
            </div>
        );
    }

    const { aiType, transactionId, totalCreditsUsed, dateTime, imageUrl, requestQues } = data;

    const handleDownload = async () => {
        try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const fileName = imageUrl.split("/").pop();
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Image download failed:", error);
        }
    };

    return (
        <div>
            <div className="h-100 companion-ai-container mb-4">
                <PageHeading
                    title={"GENERATED TOY STORIES"}
                    description={"View your generated TOY STORIES"}
                />

                <div className="container companion-ai-main">
                    <div
                        style={{
                            maxWidth: "872px",
                            paddingInline: "12px",
                            marginInline: "auto",
                        }}
                    >
                        {/* Credits Bar */}
                        <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2 mb-4">
                            <button className="credits-button">
                                CREDITS : {creditToLocalString}
                            </button>
                            <button
                                className="buy-credits-button"
                                onClick={() => navigate("/purchase")}
                            >
                                BUY CREDITS
                            </button>
                            <button
                                onClick={() => navigate("/usage")}
                                className="money-exchange-button"
                            >
                                <img src={moneyExchangeIcon} alt="exchange" />
                            </button>
                        </div>

                        {/* Topic Header */}
                        <div className="text-center mb-4">
                            <div style={{
                                background: "#011C34",
                                border: "2px solid #FFF",
                                borderRadius: "16px",
                                padding: "40px 30px",
                            }}>
                                <div style={{
                                    width: "60px",
                                    height: "60px",
                                    background: "linear-gradient(135deg, #00ff88, #00cc70)",
                                    borderRadius: "50%",
                                    margin: "0 auto 25px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "30px",
                                }}>
                                    ✓
                                </div>

                                <h4 className="text-white mb-3" style={{ fontWeight: "600" }}>
                                    {requestQues}
                                </h4>

                                <p className="text-white mb-4" style={{
                                    fontSize: "14px",
                                    opacity: 0.8,
                                    maxWidth: "600px",
                                    margin: "0 auto 20px",
                                }}>
                                    {aiType} — Image generated successfully
                                </p>

                                <div style={{
                                    background: "rgba(0, 255, 136, 0.1)",
                                    border: "2px solid rgba(0, 255, 136, 0.3)",
                                    borderRadius: "10px",
                                    padding: "10px 20px",
                                    display: "inline-block",
                                }}>
                                    <span style={{
                                        color: "#00ff88",
                                        fontWeight: "bold",
                                        fontSize: "13px",
                                        textTransform: "uppercase",
                                        letterSpacing: "1px",
                                    }}>
                                        COMPLETED
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Transaction Info */}
                        <div className="mb-3">
                            <div style={{
                                background: "#011C34",
                                border: "2px solid #FFF",
                                borderRadius: "12px",
                                padding: "15px",
                            }}>
                                <div className="row">
                                    <div className="col-md-6 mb-2">
                                        <p className="text-white mb-1" style={{ fontSize: "13px" }}>
                                            <strong>Transaction ID:</strong> {transactionId}
                                        </p>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <p className="text-white mb-1" style={{ fontSize: "13px" }}>
                                            <strong>Credits Used:</strong> {totalCreditsUsed}
                                        </p>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <p className="text-white mb-1" style={{ fontSize: "13px" }}>
                                            <strong>Date:</strong> {moment(dateTime).format("DD-MM-YYYY HH:mm:ss")}
                                        </p>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <p className="text-white mb-0" style={{ fontSize: "13px" }}>
                                            <strong>Topic:</strong> {requestQues}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Generated Image */}
                        {imageUrl && (
                            <div className="mb-3">
                                <div style={{
                                    background: "#011C34",
                                    border: "2px solid #FFF",
                                    borderRadius: "12px",
                                    padding: "15px",
                                }}>
                                    <h6 className="text-white mb-3">
                                        <strong>Generated Image</strong>
                                    </h6>
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 col-lg-6 mb-3">
                                            <div style={{
                                                background: "#001f3f",
                                                borderRadius: "10px",
                                                padding: "8px",
                                                cursor: "pointer",
                                                transition: "all 0.3s ease",
                                            }}>
                                                <img
                                                    src={imageUrl}
                                                    alt={`Generated Poster`}
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: "8px",
                                                        display: "block",
                                                    }}
                                                    onClick={() => setSelectedImage(imageUrl)}
                                                />
                                                <div className="d-flex justify-content-between align-items-center mt-2 px-1">
                                                    <span className="text-white" style={{ fontSize: "12px", opacity: 0.7 }}>
                                                        Generated Poster
                                                    </span>
                                                    <Button
                                                        sx={{
                                                            padding: "2px 12px",
                                                            fontSize: "11px",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.3)",
                                                            borderRadius: "6px",
                                                            textTransform: "none",
                                                            minWidth: "auto",
                                                            "&:hover": {
                                                                background: "rgba(255,255,255,0.1)",
                                                                border: "1px solid rgba(255,255,255,0.5)",
                                                            },
                                                        }}
                                                        onClick={() => handleDownload()}
                                                    >
                                                        Download
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="text-warning text-center pt-4 mb-0">
                                    Please download the image within 30 days, as it will
                                    be deleted after that time.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Lightbox Modal */}
            {selectedImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "12px",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "20px",
                            right: "30px",
                            color: "#fff",
                            fontSize: "30px",
                            cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(null)}
                    >
                        ✕
                    </div>
                </div>
            )}
        </div>
    );
}